import * as React from "react";
const SvgClose = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 14 14"
    {...props}
  >
    <path
      d="M13.624.375a.75.75 0 0 1 0 1.061L1.437 13.624a.75.75 0 0 1-1.061-1.061L12.563.375a.75.75 0 0 1 1.061 0ZM.376.375a.75.75 0 0 1 1.06 0l12.188 12.188a.75.75 0 1 1-1.06 1.06L.375 1.437a.75.75 0 0 1 0-1.06Z"
      fill={props.color}
    />
  </svg>
);
export default SvgClose;
